import { createContext, useState, memo, ReactNode } from 'react';
import { noop } from 'lodash';
import { useVizGraphqlPromise } from './viz-query.hook';
import { VizQueryPromiseData } from '../../common/redux/actions/DiscoverActions';
import { isDashletMode } from '../../auth';

export const VizPromiseContext = createContext<{
  promise: Promise<VizQueryPromiseData>;
  forceReQuery: () => void;
}>({
  promise: undefined,
  forceReQuery: noop,
});

/**
 * VizPromiseProvider - purpose built to update only when the viz needs a new query
 * note the minimal dependencies. A 'force re-query' hook can be supplied here to
 * force a new query
 */
export const VizPromiseProvider = memo<{ children: ReactNode }>(
  ({ children }) => {
    const [_forceUpdate, setForceUpdate] = useState<number>(0);
    // the promise must be in a parent, non-suspended, component because
    // suspended children are always re-rendered. Otherwise, we'll have an infinite loop
    const vizQueryPromise = useVizGraphqlPromise({
      skipAnalyze: isDashletMode(),
    });

    return (
      <VizPromiseContext.Provider
        value={{
          promise: vizQueryPromise,
          forceReQuery: () => setForceUpdate((_forceUpdate + 1) % 2),
        }}
      >
        {children}
      </VizPromiseContext.Provider>
    );
  },
);
